function getClosestEntrance(
  angle: number,
  subzones: string[]
): string | undefined {
  const angleValue = angle % 360;

  const best = subzones.reduce<{ diff: number; subzone?: string }>(
    (acc, sub) => {
      const match = sub.match(/\d+/);
      if (!match) return acc;
      const num = parseInt(match[0]);
      const diff = Math.abs(num - angleValue);
      return diff < acc.diff ? { diff, subzone: sub } : acc;
    },
    { diff: Infinity }
  );

  return best.subzone;
}
export default getClosestEntrance;
